import { PlanState } from 'types';
import type { Plan } from 'types';

/**
 * A plan is "active" once it has been activated: it is no longer deactivated and
 * has reached the READY state. While active, its draft configuration is locked
 * and can no longer be edited in the Survey Results Season flow.
 */
export function isPlanActive(plan?: Plan | null): boolean {
  return !!plan && !plan.deactivated && plan.state === PlanState.READY;
}

/**
 * A plan is "activating" while its activation job runs asynchronously: it has
 * left DRAFT for the CREATING state but is not yet READY. The activate step shows
 * an in-progress placeholder and locks navigation during this window.
 */
export function isPlanActivating(plan?: Plan | null): boolean {
  return !!plan && plan.state === PlanState.CREATING;
}
